import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/case-study/saa-portal/saa-portal-case-study.tsx");
